import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import { classNames } from '../_common/defaultImports';
import { ConditionalWrap } from '../conditional-wrap';
export const Skeleton = React.forwardRef(function Skeleton({ as, variant = 'rectangular', className, style, height, width, isLoading = true, children, htmlAttributes, onBackground = 'default', }, ref) {
    const Component = as || 'div';
    const classes = classNames(`ndl-skeleton ndl-skeleton-${variant}`, onBackground && `ndl-skeleton-${onBackground}`, className);
    return (_jsx(ConditionalWrap, { shouldWrap: isLoading, wrap: (children) => (_jsx(Component, Object.assign({ ref: ref, className: classes, style: Object.assign(Object.assign({}, style), { height,
                width }), "aria-busy": true, tabIndex: -1 }, htmlAttributes, { children: _jsx("div", { "aria-hidden": isLoading, className: "ndl-skeleton-content", tabIndex: -1, children: children }) }))), children: children }));
});
//# sourceMappingURL=Skeleton.js.map